import { ConnectorFlowInstanceDTO } from '@/models/connectors';
import { DistributionChannel } from '@/models/distributionChannels';
import { t } from 'i18next';
import { FC } from 'react';

type AudienceDestinationTableCaptionProps = {
  destinations: DistributionChannel[];
  flowInstances: ConnectorFlowInstanceDTO[];
};

export const AudienceDestinationTableCaption: FC<AudienceDestinationTableCaptionProps> = ({ destinations, flowInstances }) => {
  const totalConnections = destinations.length + flowInstances.length;
  
  return (
    <div className='flex items-center gap-3'>
      <h3 className='text-lg font-semibold text-secondary-700'>{t('audience_details:destinations.title')}</h3>
      {totalConnections > 0 && (
        <div className='flex size-6 items-center justify-center gap-2 rounded-full border bg-gray-50 text-center text-primary-900'>
          <p className='text-sm'>{totalConnections}</p>
        </div>
      )}
    </div>
  );
};
